import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { history } from 'store'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import queryString from 'query-string'
import { croppedImg } from 'utils'

import Cart from 'components/Cart'
import GiftCardAmount from 'components/GiftCardAmount'

import {
  update,
  clearGiftCard as clearGiftCardAction,
  create,
  fetch,
} from 'actions/gift-card'
import { authenticationRequest as authenticationRequestAction } from 'actions/authentication'

export class GiftCard extends React.Component {
  componentDidMount() {
    this.fetch()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { giftCardLanguage } = this.props

    if (giftCardLanguage !== nextProps.giftCardLanguage) {
      this.fetch()
    }
  }

  fetch() {
    const { match, fetchGiftCard } = this.props
    const { cellarId, giftCardId } = match.params
    const { lang } = queryString.parse(window.location.search)

    fetchGiftCard(cellarId, giftCardId, lang)
  }

  backToCellar(e) {
    e.preventDefault()
    e.stopPropagation()
    const { match } = this.props
    const { giftCardId } = match.params
    const { pathname, search } = window.location
    const url = `${pathname.replace(`/gift-cards/${giftCardId}`, '')}${search}`
    return history.replace(url)
  }

  render() {
    const {
      giftCard,
      authenticationRequest,
      updateGiftCard,
      clearGiftCard,
      createGiftCard,
      match,
    } = this.props

    const { cellarId, giftCardId } = match.params
    const company = ''
    const { title, description, data: { amount }, currency, mainImage, expiryMonths } = giftCard

    const topComponent = (
      <div className="grid">
        <div className="grid__item lap-6-12">
          <h2 className="beta space--bottom-1">
            { title }
          </h2>
          <p
            className="space--both-1"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          ></p>
        </div>
        <div className="grid__item lap-6-12">
          <img src={ croppedImg(mainImage, 730, 300) }></img>
        </div>
      </div>
    )

    const paymentInfo = (
      <div>
        <h2 className="beta space--bottom-1">
          <FormattedMessage
            id="app.gift-card.cart.title"
          />
        </h2>
        <p className="space--both-1">
          <FormattedMessage
            id="app.gift-card.cart.description"
            values={{ expiryMonths }}
          />
        </p>
        { !!amount &&
          <p className="space--both-1">
            <FormattedHTMLMessage
              id="app.gift-card.cart.amount"
              values={{ amount, currency }}
            />
          </p>
        }
      </div>
    )

    const GiftCardCart = React.createFactory(Cart)({
      cart: giftCard,
      cellarId,
      resourceId: cellarId,
      authenticationRequest,
      updateCart: updateGiftCard,
      cartOperation: (id, data) => {
        const dataWithLanguage = Object.assign(
          {},
          data,
          { ui_language: this.props.giftCardLanguage }
        )
        return createGiftCard(id, giftCardId, dataWithLanguage)
      },
      clearCart: clearGiftCard,
      company,
      disableAuth: true,
      disableSummary: true,
      disableCoupon: true,
      finalButtonTitle: '',
      stepsBeforeAuth: [
        {
          key: 'gift-card',
          title: '',
          component: GiftCardAmount,
        },
      ],
      paymentInfo,
      amount,
      currency,
      topComponent,
      backLinkText: 'app.cart.gift-card.back',
      backLinkFunction: this.backToCellar.bind(this),
      finishButtonText: 'app.cart.buy-now',
    })

    return GiftCardCart
  }
}

GiftCard.propTypes = {
  giftCard: PropTypes.object.isRequired,
  authenticationRequest: PropTypes.func.isRequired,
  updateGiftCard: PropTypes.func.isRequired,
  clearGiftCard: PropTypes.func.isRequired,
  createGiftCard: PropTypes.func.isRequired,
  fetchGiftCard: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  giftCardLanguage: PropTypes.string.isRequired,
}

function mapStateToProps(state) {
  return {
    giftCard: state.giftCard,
    giftCardLanguage: state.languages.cellarLanguage,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    authenticationRequest: authenticationRequestAction,
    updateGiftCard: update,
    clearGiftCard: clearGiftCardAction,
    createGiftCard: create,
    fetchGiftCard: fetch,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(GiftCard)
